import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { DatahubService } from '../../../services/datahub.service';
@Component({
  selector: 'app-modal-content-about',
  templateUrl: './modal-content-about.component.html',
  styleUrl: './modal-content-about.component.css',
  standalone: false,
})
export class ModalContentAboutComponent {
  public appVersion: string = environment.appVersion;
  public readonly envName = environment.environmentNameFull;
  public logRocket$ = this.datahub.logRocket.ready$;

  private readonly window = this.document.defaultView;

  constructor(
    private readonly datahub: DatahubService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  public get userName(): string {
    return this.datahub.user.userName;
  }

  public get employeeNumber(): string {
    return this.datahub.user.getEmpId();
  }

  public get homeCostCenter(): string {
    return this.datahub.user.getHomeCC();
  }

  public clearLocalStorageAndReload(): void {
    this.window.localStorage.clear();
    this.window.location.reload();
  }
}
